import React, { useEffect } from "react";
import { Route, Routes, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { CombinedReducersType } from "@type/index";
import { AppActions } from "@redux/reducer";
import { getUA } from "react-device-detect";
import {
  UQ_JP_JA_Android_UserAgent,
  UQ_JP_JA_Ios_UserAgent,
  UQ_US_EN_Android_UserAgent,
  UQ_US_EN_Ios_UserAgent,
  FR_UserAgent,
  guIOSPattern,
  guAndroidPattern
} from "@util/config";
import i18next from "i18next";
import "@util/firebase";
import { convertRegionNameForWording } from "@util/country";
import SearchResult from "./SearchResult";
import PublicHeader from "../common/PublicHeader";
import PublicFooter from "../common/PublicFooter";
import ImageSearch from "./ImageSearch";
import NotFound from "../common/NotFound";
import ServerError from "../common/ServerError";

const App = () => {
  const { language, region } = useParams();
  const dispatch = useDispatch();
  const appStore = useSelector((state: CombinedReducersType) => state.app);
  useEffect(() => {
    i18next.changeLanguage(
      `${language}-${convertRegionNameForWording(region || "")}`
    );
    dispatch(
      AppActions.setLanguageRegion({
        language: language || "",
        region: region || ""
      })
    );
    if (
      getUA.indexOf(UQ_JP_JA_Ios_UserAgent) > -1 ||
      getUA.indexOf(UQ_JP_JA_Android_UserAgent) > -1 ||
      getUA.indexOf(UQ_US_EN_Ios_UserAgent) > -1 ||
      getUA.indexOf(UQ_US_EN_Android_UserAgent) > -1 ||
      getUA.indexOf(FR_UserAgent) > -1 ||
      guIOSPattern.test(getUA) ||
      guAndroidPattern.test(getUA)
    ) {
      dispatch(AppActions.setIsApp(true));
    }
  }, [dispatch, language, region]);

  useEffect(() => {
    const isNotUserFirst = window.localStorage.getItem("isNotUserFirst");
    if (!isNotUserFirst) {
      dispatch(AppActions.setTagDotActive(true));
    } else {
      dispatch(AppActions.setTagDotActive(false));
    }
  }, []);

  return (
    <div lang={appStore.language}>
      <PublicHeader />
      {!appStore.isVisibleError && !appStore.isVisibleNotFound && (
        <Routes>
          <Route path={"image-search"} element={<ImageSearch />} />
          <Route path={"image-search/search/*"} element={<SearchResult />} />
          <Route path={"image-search/503"} element={<ServerError />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      )}
      {appStore.isVisibleNotFound && <NotFound />}
      {appStore.isVisibleError && <ServerError />}
      <PublicFooter />
    </div>
  );
};

export default App;
